import React from "react";
import { Paper, Typography, Box } from "@mui/material";
import bankIcons from "../assets/images/bankIcons.png";
import mastercard from "../assets/images/mastercard.png";
import visa from "../assets/images/visa.png";
import capitecPay from "../assets/images/capitecPay.png";
import OzowImage from "../assets/images/ozow.svg";
import PeachPaymentImage from "../assets/images/peach-payment-logo.svg";

const paymentOptions = [
    {
        text: "Card",
        value: "stitch-card",
        images: [
            { src: mastercard, classes: "h-6 sm:h-6 md:h-7" },
            { src: visa, classes: "h-6 sm:h-6 md:h-7" },
        ],
    },
    {
        text: "Bank",
        value: "stitch-bank",
        images: [{ src: bankIcons, classes: "h-6 sm:h-6 md:h-7" }],
    },
    {
        text: "Capitec Pay",
        value: "stitch-capitec",
        images: [{ src: capitecPay, classes: "h-8 sm:h-7 md:h-12" }],
    },
    {
        text: "OZOW",
        value: "ozow",
        images: [{ src: OzowImage, classes: "h-24 sm:h-24 md:h-24" }],
    },
    {
        text: "Peach Payment",
        value: "peach",
        images: [{ src: PeachPaymentImage, classes: "h-16 sm:h-20 md:h-24" }],
    },
];

const SelectPaymentOptions = ({ set_payment_option, selected_payment }) => {
  return (
    <>
      {paymentOptions.map((option) => {
       
        return (
          <Box
            key={option.value}
            className="m-2 cursor-pointer transition-all"
            onClick={() => set_payment_option(option)}
            >
            <Paper
                className={`flex justify-between items-center p-4 h-16 text-center transition-all
                ${selected_payment?.value === option.value ? "border-2 border-blue-600 bg-blue-50" : "border border-gray-200 bg-white"}
                hover:bg-gray-100`}
            >
                <Typography style={{"fontFamily":"Montserrat"}}>{option.text}</Typography>
                <Box className="flex items-center gap-2">
                {option.images.map((img, idx) => (
                    <div key={idx} className="flex items-center justify-center">
                    <img src={img.src} alt={option.text} className={img.classes + " object-contain"} />
                    </div>
                ))}
                </Box>
            </Paper>
            </Box>
        );
      })}
    </>
  );
};

export default SelectPaymentOptions;